import { ReactNode } from 'react';
import styled from 'styled-components';

import { Tab, TabBar } from 'atoms/navigation/TabBar';

const StyledTabBar = styled(TabBar)`
  --active-fg-color: var(--c-white);
  --active-bg-color: var(--c-nd-200);
`;
const StyledTab = styled(Tab)`
  width: 50%;
`;
type Props = {
  checked: boolean;
  onChange: (value: boolean) => void;
  onLabel: ReactNode;
  offLabel: ReactNode;
  compact?: boolean;
};

export const TextSwitch = ({
  checked,
  onChange,
  onLabel,
  offLabel,
  compact,
}: Props) => {
  return (
    <StyledTabBar
      compact={compact}
      fullWidth
      forceMobileLayout
      value={checked.toString()}
    >
      <StyledTab value="true" onClick={() => onChange(true)}>
        {onLabel}
      </StyledTab>
      <Tab value="false" onClick={() => onChange(false)}>
        {offLabel}
      </Tab>
    </StyledTabBar>
  );
};
